import { BreadcrumbDefinition } from 'xng-breadcrumb/lib/types';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { SupplierDeliveryNoteDetailComponent } from '../documents/supplier-delivery-notes/supplier-delivery-note-detail/supplier-delivery-note-detail.component';
import { SupplierDeliveryNoteListComponent } from '../documents/supplier-delivery-notes/supplier-delivery-note-list/supplier-delivery-note-list.component';
import { SupplierOpenOrderLinesListComponent } from '../documents/supplier-open-order-lines/supplier-open-order-lines-list.component';
import { SupplierPurchaseOrderDetailComponent } from '../documents/supplier-purchase-orders/supplier-purchase-order-detail/supplier-purchase-order-detail.component';
import { SupplierPurchaseOrderListComponent } from '../documents/supplier-purchase-orders/supplier-purchase-order-list/supplier-purchase-order-list.component';
import { SupplierQuoteDetailComponent } from '../documents/supplier-quotes/supplier-quote-detail/supplier-quote-detail.component';
import { SupplierQuoteListComponent } from '../documents/supplier-quotes/supplier-quote-list/supplier-quote-list.component';
import { SupplierReturnNoteDetailComponent } from '../documents/supplier-return-note/supplier-return-note-detail/supplier-return-note-detail.component';
import { SupplierReturnNoteListComponent } from '../documents/supplier-return-note/supplier-return-note-list/supplier-return-note-list.component';
import { SupplierPreparationDetailComponent } from '../documents/supplier-preparations/supplier-preparation-detail/supplier-preparation-detail.component';
import { SupplierPreparationListComponent } from '../documents/supplier-preparations/supplier-preparation-list/supplier-preparation-list.component';
import {
  LogisticFeatureDefinition,
  PurchaseFeatureDefinition,
} from '@digiwall/goliath-documents/config';
import { LowerCasePipe } from '@angular/common';

const routes: Routes = [
  {
    path: 'documents',
    children: [
      {
        path: 'supplier-quotes',
        pathMatch: 'full',
        title: 'Doc::Menu:SupplierQuotes',
        canMatch: [PurchaseFeatureDefinition],
        component: SupplierQuoteListComponent,
      },
      {
        path: 'supplier-quotes',
        title: 'Doc::Menu:SupplierQuotes',
        canMatch: [PurchaseFeatureDefinition],
        data: {
          breadcrumb: {
            label: 'Doc::Menu:SupplierQuotes',
          } as BreadcrumbDefinition,
        },
        children: [
          {
            path: ':id',
            data: {
              breadcrumb: {
                alias: 'entityName',
              } as BreadcrumbDefinition,
            },
            component: SupplierQuoteDetailComponent,
          },
        ],
      },
      {
        path: 'supplier-purchase-orders',
        pathMatch: 'full',
        title: 'Doc::Menu:SupplierPurchaseOrders',
        canMatch: [PurchaseFeatureDefinition],
        component: SupplierPurchaseOrderListComponent,
      },
      {
        path: 'supplier-purchase-orders',
        title: 'Doc::Menu:SupplierPurchaseOrders',
        canMatch: [PurchaseFeatureDefinition],
        data: {
          breadcrumb: {
            label: 'Doc::Menu:SupplierPurchaseOrders',
          } as BreadcrumbDefinition,
        },
        children: [
          {
            path: ':id',
            data: {
              breadcrumb: {
                alias: 'entityName',
              } as BreadcrumbDefinition,
            },
            component: SupplierPurchaseOrderDetailComponent,
          },
        ],
      },
      {
        path: 'supplier-delivery-notes',
        pathMatch: 'full',
        title: 'Doc::Menu:SupplierDeliveryNotes',
        canMatch: [PurchaseFeatureDefinition],
        component: SupplierDeliveryNoteListComponent,
      },
      {
        path: 'supplier-delivery-notes',
        title: 'Doc::Menu:SupplierDeliveryNotes',
        canMatch: [PurchaseFeatureDefinition],
        data: {
          breadcrumb: {
            label: 'Doc::Menu:SupplierDeliveryNotes',
          } as BreadcrumbDefinition,
        },
        children: [
          {
            path: ':id',
            data: {
              breadcrumb: {
                alias: 'entityName',
              } as BreadcrumbDefinition,
            },
            component: SupplierDeliveryNoteDetailComponent,
          },
          {
            path: 'entry/:id',
            data: {
              breadcrumb: {
                label: 'Doc::Menu:StockDocs:Entry',
                alias: 'entityName',
              } as BreadcrumbDefinition,
            },
            component: SupplierDeliveryNoteDetailComponent,
          },
        ],
      },
      {
        path: 'supplier-return-notes',
        pathMatch: 'full',
        title: 'Doc::Menu:SupplierReturnNotes',
        canMatch: [PurchaseFeatureDefinition],
        component: SupplierReturnNoteListComponent,
      },
      {
        path: 'supplier-return-notes',
        title: 'Doc::Menu:SupplierReturnNotes',
        canMatch: [PurchaseFeatureDefinition],
        data: {
          breadcrumb: {
            label: 'Doc::Menu:SupplierReturnNotes',
          } as BreadcrumbDefinition,
        },
        children: [
          {
            path: ':id',
            data: {
              breadcrumb: {
                alias: 'entityName',
              } as BreadcrumbDefinition,
            },
            component: SupplierReturnNoteDetailComponent,
          },
        ],
      },
      {
        path: 'supplier-preparations',
        pathMatch: 'full',
        title: 'Doc::Menu:SupplierPreparations',
        canMatch: [PurchaseFeatureDefinition, LogisticFeatureDefinition],
        component: SupplierPreparationListComponent,
      },
      {
        path: 'supplier-preparations',
        title: 'Doc::Menu:SupplierPreparations',
        canMatch: [PurchaseFeatureDefinition, LogisticFeatureDefinition],
        data: {
          breadcrumb: {
            label: 'Doc::Menu:SupplierPreparations',
          } as BreadcrumbDefinition,
        },
        children: [
          {
            path: ':id',
            data: {
              breadcrumb: {
                alias: 'entityName',
              } as BreadcrumbDefinition,
            },
            component: SupplierPreparationDetailComponent,
          },
        ],
      },
      {
        path: 'supplier-open-order-lines',
        pathMatch: 'full',
        title: 'Doc::Menu:SupplierOpenOrderLines',
        canMatch: [PurchaseFeatureDefinition],
        component: SupplierOpenOrderLinesListComponent,
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [LowerCasePipe],
})
export class GoliathDocumentsPurchaseRoutingModule {}
